import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { stageKeys } from '../../core/diagnostic'

export default function StageRail({ question, onStageSelect, disabled }) {
  const { t } = useTranslation()
  const stageIndex = Math.max((question?.stage || 1) - 1, 0)
  const progress = question?.questionIndex && question?.totalQuestions
    ? (question.questionIndex / question.totalQuestions) * 100
    : ((question?.stage || 1) / (question?.totalStages || stageKeys.length)) * 100
  const stageLabels = stageKeys.map((key) => t(`stages.${key}`))

  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%', bgcolor: 'background.paper' }}>
      <Stack spacing={2.5} height="100%">
        <Box>
          <Stack direction="row" justifyContent="space-between" mb={1}>
            <Typography variant="caption" color="text.secondary">
              {t('questionnaire.progress')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {Math.round(progress)}%
            </Typography>
          </Stack>
          <LinearProgress variant="determinate" value={progress} sx={{ height: 8, borderRadius: 99 }} />
        </Box>
        <Stack spacing={1}>
          {stageLabels.map((label, index) => {
            const active = index === stageIndex
            const complete = index < stageIndex
            const canNavigate = complete && !disabled

            return (
              <Stack
                key={label}
                component={canNavigate ? 'button' : 'div'}
                type={canNavigate ? 'button' : undefined}
                direction="row"
                alignItems="center"
                spacing={1.2}
                onClick={canNavigate ? () => onStageSelect(index + 1) : undefined}
                sx={{
                  p: 0,
                  border: 0,
                  bgcolor: 'transparent',
                  font: 'inherit',
                  textAlign: 'left',
                  cursor: canNavigate ? 'pointer' : 'default',
                  color: active ? 'text.primary' : 'text.secondary',
                  '&:hover': canNavigate
                    ? {
                        color: 'text.primary',
                      }
                    : undefined,
                }}
              >
                {complete ? (
                  <CheckCircleIcon color="success" fontSize="small" />
                ) : (
                  <RadioButtonUncheckedIcon color={active ? 'primary' : 'disabled'} fontSize="small" />
                )}
                <Typography variant="body2" fontWeight={active ? 700 : 500}>
                  {label}
                </Typography>
              </Stack>
            )
          })}
        </Stack>
        <Box flexGrow={1} />
        <Typography variant="caption" color="text.secondary">
          {t('questionnaire.shortcuts')}
        </Typography>
      </Stack>
    </Paper>
  )
}
